

var agt = navigator.userAgent.toLowerCase();
var view_domain = document.domain;
var is_major = parseInt(navigator.appVersion);
var is_minor = parseFloat(navigator.appVersion);

var is_moz = ((agt.indexOf('mozilla') != -1) && (agt.indexOf('spoofer') == -1)
		&& (agt.indexOf('compatible') == -1) && (agt.indexOf('opera') == -1)
		&& (agt.indexOf('webtv') == -1) && (agt.indexOf('hotjava') == -1));
var is_moz2 = (is_moz && (is_major == 2));
var is_moz3 = (is_moz && (is_major == 3));
var is_moz4 = (is_moz && (is_major == 4));
var is_gecko = (agt.indexOf('gecko') != -1);

/**
 * 브라우져가 firefox 일 경우 변수의 값
 * @type boolean
 * @global is_firefox
 */
var is_firefox = (agt.indexOf('firefox') != -1);

var is_nav2 = is_moz2;
var is_nav3 = is_moz3;
var is_nav4 = is_moz4;
var is_nav4up = (is_nav4 || ((is_major >= 4) && (agt.indexOf("netscape") != -1)));
var is_nav = (is_nav2 || is_nav3 || is_nav4);

var is_mozilla = (is_moz && is_gecko);
var is_mozilla1 = (is_moz && is_gecko && (agt.indexOf("rv:1") != -1));
/**
 * 브라우져가 인터넷 익스플러러일 경우 변수의 값
 * @type boolean
 * @global is_ie
 */
var is_ie = ((agt.indexOf("msie") != -1) && (agt.indexOf("opera") == -1));
var is_ieVersion = 0;
var is_ie6 = (is_ie && (is_major == 4) && (agt.indexOf("msie 6.") != -1));
if (is_ie6) {
	is_ieVersion = 6;
}
/**
 * 브라우져가 인터넷 익스플러러 7 버전일 경우 변수의 값
 * @type boolean
 * @global is_ie7
 */
var is_ie7 = (is_ie && (is_major == 4) && (agt.indexOf("msie 7.") != -1));
if (is_ie7) {
	is_ie6 = false;
	is_ieVersion = 7;
}
/**
 * 브라우져가 인터넷 익스플러러 8 버전일 경우 변수의 값
 * @type boolean
 * @global is_ie8
 */
var is_ie8 = (is_ie && (is_major == 4) && (agt.indexOf("msie 8.") != -1));
if (is_ie8) {
	is_ie6 = false;
	is_ie7 = false;
	is_ieVersion = 8;
}
/**
 * 브라우져가 인터넷 익스플러러 9 버전일 경우 변수의 값
 * @type boolean
 * @global is_ie9
 */
var is_ie9 = (is_ie && (is_major == 5) && (agt.indexOf("msie 9.") != -1));
if (is_ie9) {
	is_ie6 = false;
	is_ie7 = false;
	is_ie8 = false;
	is_ieVersion = 9;
}
/**
 * 브라우져가 인터넷 익스플러러 10 버전일 경우 변수의 값
 * @type boolean
 * @global is_ie10
 */
var is_ie10 = (is_ie && (is_major == 5) && (agt.indexOf("msie 10.") != -1));
if (is_ie10) {
	is_ie6 = false;
	is_ie7 = false;
	is_ie8 = false;
	is_ie9 = false;
	is_ieVersion = 10;
}
/**
 * 브라우져가 인터넷 익스플러러 11 버전일 경우 변수의 값
 * @type boolean
 * @global is_ie11
 */
var is_ie11 = (is_gecko && !is_firefox && (is_major == 5) && (agt.indexOf("rv:11.") != -1));
if (is_ie11) {
	is_ie6 = false;
	is_ie7 = false;
	is_ie8 = false;
	is_ie9 = false;
	is_ie10 = false;
	is_ie = true;
	is_ieVersion = 11;
}
var is_window = (agt.indexOf('windows') != -1);

/**
 * 브라우져가 chrome 일 경우 변수의 값
 * @type boolean
 * @global is_chrome
 */
var is_chrome = !is_ie && (agt.indexOf("chrome") != -1) ? true : false;
var is_chrome58 = false;
if(is_chrome){
	var tempVer = agt.match(/chrome\/([0-9]+)\./g);
	if(null != tempVer){
		if(Number(tempVer[0].substring(7)) > 57){
			is_chrome58 = true;
		}
	}
}
/**
 * 브라우져가 edge 일 경우 변수의 값
 * @type boolean
 * @global is_edge
 */
var is_edge = is_chrome && (agt.indexOf("edge") != -1);

/**
 * 브라우져가 opera 일 경우 변수의 값
 * @type boolean
 * @global is_opera
 */
var is_opera = is_chrome && (agt.indexOf("opr/") != -1);
/**
 * 브라우져가 safari 일 경우 변수의 값
 * @type boolean
 * @global is_safari
 */
var is_safari = (agt.indexOf('safari') != -1 && !is_chrome);
/**
 * 브라우져가 window safari 일 경우 변수의 값
 * @type boolean
 * @global is_window_safari
 */
var is_window_safari = (is_safari && agt.indexOf('windows') != -1);
var is_crOs = is_chrome && (agt.indexOf("csos") != -1);

var is_chromeFrame = !is_ie && is_chrome;
// webkit Based
var is_webkit = is_safari || is_chrome;

var is_mozBrowser = is_firefox || is_opera;

//FOR TABLET PC
var is_ipad = ((is_safari || is_moz || (agt.indexOf('applewebkit') != -1)) && (agt.indexOf('ipad') != -1));

//FOR SMART PHONE
var is_iphone = ((is_safari  || is_moz || (agt.indexOf('applewebkit') != -1)) && (agt.indexOf('iphone') != -1));

var is_apple = (is_ipad || is_iphone);
var is_android = (agt.indexOf('android') != -1);
var is_opera_mini = (agt.indexOf('opera mini') != -1);

var is_android_mobile = (is_android && agt.indexOf('mobile') != -1);
var is_android_tablet = (is_android && !is_android_mobile);
var is_android_mobile44= (is_android_mobile && agt.indexOf('android 4.') != -1);

var is_samsung_browser = (is_android && (agt.indexOf('samsungbrowser') != -1));

/**
 * 기계가 mobile 일 경우 변수의 값
 * @type boolean
 * @global is_mobile
 */
var is_mobile = (is_iphone || is_android_mobile);
/**
 * 기계가 tablet 일 경우 변수의 값
 * @type boolean
 * @global is_tablet
 */
var is_tablet = (is_ipad || is_android_tablet);

var is_smartphone = false;
is_smartphone = (is_iphone || is_opera_mini || is_ipad || is_android);
var is_svg = true;
if (typeof window.SVGAElement == 'undefined') {
	is_svg =false;
	if(!is_ie6 && !is_ie7 && !is_ie8){
		is_ie7 = true;
	}
	is_ie = true;
	is_ie9 = false;
	is_ie10 = false;
	is_ie11 = false;
	is_ieVersion = 7;
}
else if(is_ie7 || is_ie8){
	is_svg = false;
}


var is_appControl = false;
var is_exeControl = false;
var is_exeMirroring = false;
var is_exeMirroringMain = false;
var is_exeMirroringSub = false;
if(is_svg){
	is_appControl = (typeof ClipHybrid != 'undefined') && (typeof ClipHybrid.callNativeControl != 'undefined');

	is_exeMirroringSub = (window.external) && ('ClipSubWebBrowserCtrl_Invoke' in window.external);
	is_exeControl = is_exeMirroringSub;

	is_exeMirroringMain = (window.external) && ('ClipMainWebBrowserCtrl_Invoke' in window.external);
	is_exeMirroring = is_exeMirroringMain || is_exeMirroringSub;
}


var Re_zoom = {
		isPop : false,
		rate : 1
};
var mRe_pallet = null;

var is_PosiFix = true;

var this_plugin

var getAcrobatInfo = function() {
	var getActiveXObject = function(name) {
		try {
			return new ActiveXObject(name);
		} catch (e) {
			window.mRe_ccancels = e.message;
		}
	};
	var getNavigatorPlugin = function(name) {
		for (var key in navigator.plugins) {
			var plugin = navigator.plugins[key];
			if (plugin.name == name)
				return plugin;
		}
	};
	var getPDFPlugin = function() {

		return this_plugin = this_plugin || function() {
					if (is_ie || is_ie11) {
						//
						// load the activeX control
						// AcroPDF.PDF is used by version 7 and later
						// PDF.PdfCtrl is used by version 6 and earlier
						return getActiveXObject('AcroPDF.PDF')
								|| getActiveXObject('PDF.PdfCtrl');
					} else {
						return getNavigatorPlugin('Chromium PDF Viewer')
								|| getNavigatorPlugin('Chrome PDF Viewer')
								|| getNavigatorPlugin('Adobe Acrobat')
								|| getNavigatorPlugin('WebKit built-in PDF');
					}
				}();
	};

	var isAcrobatInstalled = function() {
		return !!getPDFPlugin();
	};

	var getAcrobatVersion = function() {
		try {
			var plugin = getPDFPlugin();

			if (is_ie || is_ie11) {
				var versions = plugin.GetVersions().split(',');
				var latest = versions[0].split('=');
				return parseFloat(latest[1]);
			}

			if (plugin.version)
				return parseInt(plugin.version);
			return plugin.name;

		} catch (e) {
			return null;
		}
	};
	return {
		acrobat : isAcrobatInstalled() ? true : false,
		acrobatVersion : getAcrobatVersion()
	};
};

var checkPrintAble = function () {

  var m_report_printOption = getAcrobatInfo(); // pdf 인쇄 가능한지 확인 ?
  // {acrobat: false, acrobatVersion: null} -- IE
  // {acrobat: true, acrobatVersion: "Chrome PDF Viewer"} -- 크롬.. 또는 PDF 출력 가능할때
  // console.log("m_report_printOption = ", m_report_printOption)

  var pdfMode = true

  if (m_report_printOption && m_report_printOption.acrobat == true) { // pdf 출력 가능
    //alert(m_report_printOption.acrobatVersion)
    console.log(m_report_printOption.acrobatVersion);
    var ver = m_report_printOption.acrobatVersion
    if (!isNaN(ver)) {
      console.log("숫자다")
      if (ver < 10.0) {
        console.log("낮은버전")
        pdfMode = false
        } else {
          console.log("높은버전 OK")
        }
    }

    // report.printView();
    // report.view();
  } else {
    pdfMode = false
  }

  return pdfMode

}


export default {
  getAcrobatInfo,
  checkPrintAble,
}